module.exports = __webpack_public_path__ + "static/media/hero-image-1.f7003967.png";